<template>
    <div
        :class="[
            parentClass,
            'form-group',
        ]"
    >
        <div class="custom-control custom-switch">
            <input
                v-model="inputValue"
                v-bind="$attrs"
                @change="handleInput"
                :id="uniqueId"
                type="checkbox"
                class="custom-control-input"
            >
            <label
                v-if="label"
                :for="uniqueId"
                class="custom-control-label"
            >
                {{ label }}
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormSwitch',
        inheritAttrs: false,
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            label: {
                required: true,
                type: String,
            },
            parentClass: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                focus: false,
                inputValue: null,
            };
        },
        computed: {
            uniqueId() {
                return this.$id('pacos-input');
            },
        },
        methods: {
            handleInput() {
                this.$emit('input', this.inputValue);
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.inputValue = value;
                },
            },
        },
    };
</script>

